/**
 * US Map Data Tag
 */

document.addEventListener('DOMContentLoaded', () => {
  const maps = document.querySelectorAll('.us-map');

  // No Maps, return
  if (!maps.length) {
    return;
  }

  // Attaches click event to state element in US map and routes to state link
  const handleStateClick = (state) => {
    state.addEventListener('click', () => {
      window.location = state.dataset.link;
    });
  };

  // Toggle is-active on state hover and set html of tooltip
  // Set tooltip position based on mouse position
  const handleStateHover = (map, state) => {
    const tooltip = map.querySelector('.tooltip');
    state.addEventListener('mouseenter', () => {
      tooltip.classList.add('is-active');
      tooltip.classList.remove('hidden');
      tooltip.innerHTML = state.dataset.tooltip;
      map.addEventListener('mousemove', (e) => {
        tooltip.style.top = `${e.clientY - map.getBoundingClientRect().top - tooltip.offsetHeight - 20}px`;
        tooltip.style.left = `${e.clientX - map.getBoundingClientRect().left + 50}px`;
      });
    });
    state.addEventListener('mouseleave', () => {
      tooltip.classList.add('hidden');
      tooltip.classList.remove('is-active');
    });
  };

  // Set active state shown based on selected in mobile
  const handleStateSelect = (map) => {
    const select = map.querySelector('select');
    select.addEventListener('change', (e) => {
      const stateName = e.currentTarget.options[e.currentTarget.selectedIndex].value;
      const state = stateName
        ? document.querySelector(`[data-state="${stateName}"`)
        : '';
      const container = map.querySelector('.mobile-container');

      if (state.length === 0) {
        container.classList.remove('is-active');
        container.innerHTML = '';
      } else {
        const viewMore = state.dataset.link
          ? `<br /><a class="sonic-btn primary" href="${state.dataset.link}">More Info</a>`
          : '';

        container.classList.add('is-active');
        container.innerHTML = state.dataset.tooltip + viewMore;
      }
    });
  };

  // Apply event bindings on states
  maps.forEach((map) => {
    handleStateSelect(map);
    map.querySelectorAll('.state').forEach((state) => {
      if (state.dataset.link) {
        handleStateClick(state);
      }
      handleStateHover(map, state);
    });
  });
});
